import React from 'react';
export function Footer() {
  return <footer className="bg-ink text-cream/60 py-16 px-4" data-id="element-153">
      <div className="max-w-5xl mx-auto" data-id="element-154">
        <div className="mb-12" data-id="element-155">
          <span className="font-serif font-bold text-cream text-xl tracking-tight block mb-6" data-id="element-156">
            Rylte Health
          </span>

          <div className="space-y-4 text-sm leading-relaxed max-w-3xl" data-id="element-157">
            <p data-id="element-158">
              <strong data-id="element-159">Editorial disclosure:</strong> This article was produced
              by the Rylte Health research team and contains information about
              Nerva™, a product sold by Rylte. While the clinical citations
              referenced are peer-reviewed and publicly available, this article
              should not be taken as medical advice. Nerva™ is not intended to
              diagnose, treat, cure, or prevent any disease. If you have a
              medical condition, consult your physician before use. Individual
              results vary.
            </p>
            <p data-id="element-160">
              <strong data-id="element-161">Contraindications:</strong> Nerva™ should not be used by
              individuals with implanted electrical devices (pacemakers,
              cochlear implants), during pregnancy, or by those with a history
              of seizures without medical supervision.
            </p>
          </div>
        </div>

        <div className="pt-8 border-t border-cream/10 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs" data-id="element-162">
          <div data-id="element-163">
            © {new Date().getFullYear()} Rylte Health. All rights reserved.
          </div>
          <div className="flex gap-6" data-id="element-164">
            <a href="#" className="hover:text-cream transition-colors" data-id="element-165">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-cream transition-colors" data-id="element-166">
              Terms of Service
            </a>
            <a href="#" className="hover:text-cream transition-colors" data-id="element-167">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>;
}